import sanitizeHtml from 'sanitize-html';

/**
 * `this.$sanitize(html)` for components, replacing angular's `$sanitize`.
 *
 * sanitize-html's default whitelist already covers everything the rich text
 * editor toolbars can produce, but it drops every attribute that isn't explicitly
 * allowed. Angular's `$sanitize` kept `class` (which is how quill marks up its
 * output) and dropped `style`, so `class` is added back on every tag to keep
 * previously saved content rendering the way it used to.
 *
 * This used to go through vue-sanitize, whose whole content was `sanitize-html` plus
 * `Vue.prototype.$sanitize = ...` - vue 2's only way of putting something on every
 * instance, and a no-op against a vue 3 app. The package is gone and sanitize-html is a
 * dependency of its own now, at the version vue-sanitize was pinning it to.
 */
const options = {
    allowedTags: sanitizeHtml.defaults.allowedTags,
    allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        '*': ['class'],
    },
};

export default {
    install(app) {
        app.config.globalProperties.$sanitize = (dirty, opts = null) =>
            sanitizeHtml(dirty, opts || options);
    }
};
